import React, { useState, useEffect } from "react";
import Button from "../../../Button/Button";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import CustomerTable from "../../../Tables/UserPart/UserList/CustomerTable/CustomerTable";
import {
  deactivateUserPostApi,
  getUserInfoApi,
  getUsersListApi,
  getWalletInfoCustomerApi,
} from "../../../../Api/PanelAdminServices";
// import AddressList from '../../../Modal/Information/AddressList/AddressList'
import { Modal } from "react-bootstrap";
import SetScore from "../../../Modal/Information/SetScore/SetScore";
import EditCustomerInfo from "../../../Modal/Information/EditCustomerInfo/EditCustomerInfo";
import UserInfo from "../../../Modal/Information/UserInfo/UserInfo";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Style from "./CustomerContainer.module.scss";
import AddressList from "../../../Modal/Information/AddressList/AddressList";
import ShabaModal from "../../../Modal/Information/ShabaModal/ShabaModal";
import WalletInfo from "../../../Modal/Information/WalletInfo/WalletInfo";
import HandleMoney from "../../../Modal/Information/HandleMoney/HandleMoney";
const CustomerContainer = () => {
  /////////get data //////
  const [userList, setUserList] = useState([]);
  const [Info, setInfo] = useState([]);
  const [userId, setUserId] = useState();
  useEffect(() => {
    UserList();
  }, []);
  const UserList = async () => {
    getUsersListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setUserList(res.users);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  const [rawInfo, setRawInfo] = useState();

  const [addressVisible, setAddressVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [walletVisible, setWalletVisible] = useState(false);
  const [moneyVisible, setMoneyVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [underRef, setUnderRef] = useState(false);
  const [underRefValue, setUnderRefValue] = useState([]);
  const [wallet, setWallet] = useState();
  const [shabaAvailable, setShabaAvailable] = useState(false);
  const [disable, setDisable] = useState(false);

  // let underRefValue=[]
  const showAddress = async (id, info) => {
    getUserInfoApi(info.userId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده")
        }else{
          setInfo(res.info);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });
    setUserId(info.userId);
    setRawInfo(info);
    ///Address List///
    if (id === 1) {
      setAddressVisible(true);
    }
    ////Score/////
    if (id === 2) {
      setScoreVisible(true);
    }
    /////Edit///////
    if (id === 3) {
      setEditVisible(true);
    }
    //////Delete///////
    if (id === 4) {
      setDeleteVisible(true);
    }
    if (id === 5) {
      setUserInfo(true);
    }
    if (id === 6) {
      const valueee = userList.filter((value) => {
        return info.myRef === value.referral;
      });
      setUnderRefValue(valueee);
      setUnderRef(true);
    }
    //////shaba part////////

    if (id === 7) {
      setShabaAvailable(true);
    }
    /////wallet/////////
    if (id === 8) {
      getWalletInfoCustomerApi(info.userId,(succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش آمد")
          }else{
            res.transactions.sort((a,b)=>{
              if(a.id>b.id){
                return -1
              }else return 1
            })
            setWallet(res.transactions);
            setWalletVisible(true);
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      })
    }

    if(id===9){
      setMoneyVisible(true)
    }
  };
  const deactiveCustomer = () => {
    setDisable(true);
    let info = {
      id: userId,
      status: rawInfo.status === "1" ? "0" : "1",
      type: "user",
    };
    deactivateUserPostApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت انجام شد");
        setDisable(false);
        setDeleteVisible(false);
      } else {
        errorToast("مشکلی پیش آمد");
        setDisable(false);
        setDeleteVisible(false);
      }
      UserList();
    });
  };
  const handleOkAddress = () => {
    setAddressVisible(false)
    setDeleteVisible(false)
    setEditVisible(false)
    setScoreVisible(false)
    setUserInfo(false)
    setShabaAvailable(false)
    setUnderRef(false)
    setWalletVisible(false)
    setMoneyVisible(false)
  };
  const data =
    userList &&
    userList.map((item, index) => {
      return {
        key: index,
        id: item.id,
        first_name: item.first_name,
        last_name: item.last_name,
        phone: item.phone,
        signUpDate: item.register_date,
        scores: item.score,
        userId: item.id,
        status: item.status,
        myRef: item.my_referral,
        refCount: item.count_referral === null ? "0" : item.count_referral,
        refInvite: item.referral,
      };
    });
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div>
      <Modal show={addressVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>لیست آدرس ها</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddressList rawInfo={rawInfo} handleOk={handleOkAddress} />
        </Modal.Body>
      </Modal>

      <Modal show={userInfo} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات مشتری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo
            showAddress={false}
            Info={rawInfo}
            handleOk={handleOkAddress}
          />
        </Modal.Body>
      </Modal>

      <Modal show={underRef} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>زیرمجموعه ها </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={Style.holder}>
            {underRefValue.map((item) => {
              return (
                <div className={Style.rowHolder} key={item.id}>
                  <h2 className={Style.nameHolder}>
                    {item.first_name} {item.last_name}
                  </h2>
                  <h2 className={Style.phoneAndCity}>{item.phone}</h2>
                  <h2 className={Style.phoneAndCity}> {item.city_name}</h2>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از غیرفعال کردن کاربر موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deactiveCustomer}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={editVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>ویرایش اطلاعات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditCustomerInfo
            rawInfo={rawInfo}
            handleOkAddress={handleOkAddress}
            UserList={UserList}
            type={"user"}
          />
        </Modal.Body>
      </Modal>

      <Modal show={scoreVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اختصاص امتیاز</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SetScore
            rawInfo={rawInfo}
            handleOkAddress={handleOkAddress}
            UserList={UserList}
            type={"user"}
          />
        </Modal.Body>
      </Modal>
      <Modal show={walletVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>تراکنشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WalletInfo data={wallet} />
        </Modal.Body>
      </Modal>
      <Modal show={shabaAvailable} onHide={handleOkAddress}>
        <Modal.Body>
          <ShabaModal type={"user"} data={Info} />
        </Modal.Body>
      </Modal>

      <Modal show={moneyVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>کیف پول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HandleMoney uType={"user"} userId={userId} close={handleOkAddress}/>
        </Modal.Body>
      </Modal>

      <TableFixedPage title="لیست مشتریان" />
      <CustomerTable showAddress={showAddress} data={data} />
    </div>
  );
};

export default CustomerContainer;
